module.exports = __webpack_public_path__ + "static/media/student-score-20p.e424c906.png";